import script from "./sourcePageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./sourcePageEditor.vue?vue&type=script&setup=true&lang=js"

import "./sourcePageEditor.vue?vue&type=style&index=0&id=cff99e98&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff99e98"]])

export default __exports__